// 其他州属球场数据
// Other States Golf Courses (Perlis, Labuan, etc.)

export const OTHER_COURSES = {
  "KELAB_GOLF_PUTRA": {
    shortName: "KGP",
    fullName: "Kelab Golf Putra",
    location: ["Kangar", "Perlis", "Malaysia"],
    pars: [5,4,4,3,4,5,4,3,4, 4,5,3,4,4,4,3,4,5],
    index: [5,7,11,17,13,1,15,9,3, 8,12,18,14,4,10,16,2,6]
  },

  "PUTRA_GOLF_CLUB": {
    shortName: "PGC",
    fullName: "Putra Golf Club",
    location: ["Kangar", "Perlis", "Malaysia"],
    pars: [5,4,4,3,4,5,4,3,4, 4,5,3,4,4,4,3,4,5],
    index: [5,7,11,17,13,1,15,9,3, 8,12,18,14,4,10,16,2,6]
  },

  "LABUAN_INTERNATIONAL_GOLF_CLUB": {
    shortName: "LIGC",
    fullName: "Labuan International Golf Club",
    location: ["Labuan", "Labuan", "Malaysia"],
    pars: [4,5,5,4,3,4,3,4,4, 5,4,4,3,5,4,3,4,4],
    index: [9,3,1,13,17,11,15,5,7, 4,10,6,16,2,8,18,14,12],
  },
  
  "SEDAYU_INDO_GOLF_COURSE": {
    shortName: "SIGC",
    fullName: "Sedayu indo golf course",
    location: ["Indonesia", "Indonesia", "Indonesia"],
    pars: [4,5,4,4,3,5,3,4,4, 4,4,3,4,5,4,3,5,4],
    index: [9,3,1,7,13,17,11,15,5, 18,8,16,12,6,2,14,4,10],
  },

    "SUVARNA_JAKARTA_GOLF_CLUB_GREEN_RED": {
    shortName: "SJGC-GR",
    fullName: "Suvarna Jakarta Golf Club(Green + Red)",
    location: ["Indonesia", "Indonesia", "Indonesia"],
    pars: [4,5,5,3,4,3,4,5,3, 4,4,5,3,5,3,4,3,5],
    index: [7,13,9,5,1,11,15,3,17, 16,2,14,18,6,8,4,12,10],
  },
  
    "SUVARNA_JAKARTA_GOLF_CLUB_GREEN_BLUE": {
    shortName: "SJGC-GB",
    fullName: "Suvarna Jakarta Golf Club(Green + Blue)",
    location: ["Indonesia", "Indonesia", "Indonesia"],
    pars: [4,5,5,3,4,3,4,5,3, 5,3,4,4,4,3,5,3,5],
    index: [7,13,9,5,1,11,15,3,17, 12,16,2,10,4,18,14,6,8],
  
  },
  "SUVARNA_JAKARTA_GOLF_CLUB_RED_BLUE": {
    shortName: "SJGC-RB",
    fullName: "Suvarna Jakarta Golf Club(Red + Blue)",
    location: ["Indonesia", "Indonesia", "Indonesia"],
    pars: [4,4,5,3,5,3,4,3,5, 5,3,4,4,4,3,5,3,5],
    index: [11,15,1,9,3,17,13,5,7, 16,2,14,18,6,8,4,12,10],
  }
};

export default OTHER_COURSES;
